import { Link } from 'react-router-dom';
import { mediaList } from '@/mocks/media';

const entries = [
  {
    type: 'movie',
    label: '电影',
    desc: '院线新片 · 高分经典',
    icon: 'ri-movie-2-line',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20a%20film%20projector%20beam%20cutting%20through%20darkness%20in%20an%20empty%20theater%2C%20deep%20blue%20tones%20with%20warm%20orange%20light%2C%20moody%20digital%20painting&width=800&height=600&seq=kp-cat-01&orientation=landscape',
  },
  {
    type: 'tv',
    label: '电视剧',
    desc: '热门好剧 · 追不停',
    icon: 'ri-tv-2-line',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20cozy%20evening%20living%20room%20with%20a%20glowing%20television%20and%20warm%20lamplight%2C%20deep%20blue%20shadow%20tones%20with%20orange%20accents%2C%20inviting%20digital%20painting&width=800&height=600&seq=kp-cat-02&orientation=landscape',
  },
  {
    type: 'variety',
    label: '综艺',
    desc: '真人秀 · 音乐 · 美食',
    icon: 'ri-mic-line',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20lively%20stage%20with%20colorful%20spotlights%20and%20confetti%20above%20an%20empty%20show%20platform%2C%20deep%20blue%20background%20with%20vibrant%20orange%20and%20yellow%20lights%2C%20energetic%20digital%20painting&width=800&height=600&seq=kp-cat-03&orientation=landscape',
  },
];

export default function CategoryEntries() {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {entries.map((entry) => {
        const count = mediaList.filter((item) => item.type === entry.type).length;
        return (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group relative h-40 md:h-44 rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src={entry.image}
              alt={`${entry.label}分类`}
              title={`${entry.label} - 看片影视`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-transparent"></div>
            <div className="absolute inset-0 p-5 flex flex-col justify-end">
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className={`${entry.icon} text-2xl`}></i>
                </span>
                <div>
                  <h3 className="text-lg font-bold text-background-50">{entry.label}</h3>
                  <p className="text-xs text-background-100/85">{entry.desc}</p>
                </div>
                <span className="ml-auto text-xs text-background-50 bg-foreground-950/40 px-2.5 py-1 rounded-full">
                  {count} 部
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </section>
  );
}